module.exports = __webpack_public_path__ + "media/images/entry_pass_header-54cf9f69.png";